import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-sky-50 border-t border-sky-100">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo & Description */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/a3e68751-1994-475a-a210-c08719e23468.png"
              alt="合同会社リンク"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-slate-500 text-sm leading-relaxed">
              美容ビジネスの成功を、専門知識と<br />マーケティングの力でサポートします。
            </p>
          </div>

          {/* Company Info */}
          <div>
            <h4 className="text-slate-700 font-semibold text-sm mb-4 tracking-wider uppercase">会社情報</h4>
            <ul className="space-y-3 text-sm text-slate-500">
              <li className="flex gap-2">
                <i className="ri-map-pin-line text-sky-300 mt-0.5 flex-shrink-0"></i>
                <span>東京都豊島区南長崎三丁目7番6号<br />グランエッグス落合07号</span>
              </li>
              <li className="flex gap-2">
                <i className="ri-calendar-line text-sky-300 mt-0.5 flex-shrink-0"></i>
                <span>設立：令和6年11月13日</span>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-slate-700 font-semibold text-sm mb-4 tracking-wider uppercase">サイトマップ</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-slate-500 hover:text-sky-400 transition-colors cursor-pointer">ホーム</Link></li>
              <li><Link to="/services" className="text-slate-500 hover:text-sky-400 transition-colors cursor-pointer">サービス</Link></li>
              <li><Link to="/about" className="text-slate-500 hover:text-sky-400 transition-colors cursor-pointer">会社概要</Link></li>
              <li><Link to="/contact" className="text-slate-500 hover:text-sky-400 transition-colors cursor-pointer">お問い合わせ</Link></li>
              <li><Link to="/privacy-policy" className="text-slate-500 hover:text-sky-400 transition-colors cursor-pointer">プライバシーポリシー</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-sky-100 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-400">&copy; 2024 合同会社リンク. All rights reserved.</p>
          <Link to="/privacy-policy" className="text-xs text-slate-400 hover:text-sky-400 transition-colors cursor-pointer">
            プライバシーポリシー
          </Link>
        </div>
      </div>
    </footer>
  );
}
